import { Inject, Injectable } from "@angular/core";
import { AuthenticationModel, CheckUtils, EncryptStorageEvent, JabberEPEvent, logger, OrganizationProvider, UserActivationVoStatus, UserCategoryVoData, UserResolverVoData, UsersConverter, UsersEndPoints, UsersModel, UsersResolverModel, UserStatusVoData, UserTypeVoData, UserVoData } from "../..";
import { Events } from "ionic-angular";
import { OdConfig, OrganizationModel, UpdateModelVoData } from "../../index";
import { CacheService } from "ionic-cache";
var UsersProvider = /** @class */ (function () {
    function UsersProvider(config, usersEndPoints, _model, _events, _cache, authModel, _usersResolverModel, _organizationModel, organizationProvider) {
        this.config = config;
        this.usersEndPoints = usersEndPoints;
        this._model = _model;
        this._events = _events;
        this._cache = _cache;
        this.authModel = authModel;
        this._usersResolverModel = _usersResolverModel;
        this._organizationModel = _organizationModel;
        this.organizationProvider = organizationProvider;
        this._ready = false;
        this.bind();
    }
    UsersProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(JabberEPEvent.PRESENCE_CHANGED, function (from, type, roomId) {
            var userStatus = UserStatusVoData.OFFLINE;
            if (type === 'available') {
                userStatus = UserStatusVoData.ONLINE;
            }
            if (roomId != null)
                _this.present(from, type === 'available', roomId);
            _this.changePresence(from, userStatus);
        });
        this._cache.getNetworkStatusChanges().subscribe(function (res) { return _this.networkStatusChanges(res); });
        this._events.subscribe(EncryptStorageEvent.SECRET_PASSPHRASE_CHANGED, function (res) {
            _this._model.clear(false, true);
            _this._usersResolverModel.clear(false, true);
            if (res)
                _this._model.loadEncryptData();
        });
        this._events.subscribe(this._organizationModel.event.URI_CHANGED, function () {
            _this._model.clear(false, true);
        });
        this._events.subscribe(this._model.event.LOADED, function () {
            _this.addBot();
            _this._usersResolverModel.loadEncryptData();
        });
        this._events.subscribe(this._model.event.LOADED, function () {
            _this.addBot();
            _this._model.extraLoadEncryptData();
        });
        this._events.subscribe(this._model.event.SEQUENCE_USER_ID_LOADED, function () {
            _this._usersResolverModel.loadEncryptData();
        });
        this._events.subscribe(this._usersResolverModel.event.LOADED, function () {
            _this.addBotResolver();
            _this._ready = true;
            _this._events.publish(UsersProviderEvent.READY, _this._ready);
        });
    };
    Object.defineProperty(UsersProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UsersProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    UsersProvider.prototype.present = function (jid, available, room) {
        var userResolverVoData = this._usersResolverModel.get(jid);
        if (userResolverVoData != null) {
            if (available) {
                userResolverVoData.roomsId.push(room);
            }
            else {
                var index = userResolverVoData.roomsId.indexOf(room, 0);
                if (index > -1) {
                    userResolverVoData.roomsId.splice(index, 1);
                }
            }
            this._usersResolverModel.update(userResolverVoData.uid, [new UpdateModelVoData('roomId', userResolverVoData.roomsId)], true);
        }
    };
    UsersProvider.prototype.isPresent = function (jid) {
        var userResolverVoData = this._usersResolverModel.get(jid);
        return userResolverVoData != null && ((userResolverVoData.roomsId != null && userResolverVoData.roomsId.length > 0) ||
            userResolverVoData.userId == -2);
    };
    UsersProvider.prototype.get = function (usersId, callback) {
        var result = new Map();
        if (CheckUtils.isEmpty(usersId))
            return result;
        var toLoad = new Set();
        for (var _i = 0, _a = Array.from(usersId); _i < _a.length; _i++) {
            var userId = _a[_i];
            var user = this._model.get(userId);
            if (CheckUtils.isEmpty(user))
                toLoad.add(userId);
            else
                result.set(user.id, user);
        }
        if (CheckUtils.isEmpty(toLoad)) {
            callback(result);
        }
        else {
            this.load(toLoad, function (users) {
                for (var _i = 0, users_1 = users; _i < users_1.length; _i++) {
                    var user_1 = users_1[_i];
                    result.set(user_1.id, user_1);
                }
                callback(result);
            });
        }
    };
    UsersProvider.prototype.resolveJids = function (jids, callback) {
        var result = new Map();
        if (CheckUtils.isEmpty(jids))
            return result;
        var toLoad = [];
        for (var _i = 0, _a = Array.from(jids); _i < _a.length; _i++) {
            var jid = _a[_i];
            var userResolver = this._usersResolverModel.get(jid);
            if (CheckUtils.isEmpty(userResolver))
                toLoad.push(jid);
            else
                result.set(userResolver.uid, userResolver);
        }
        if (CheckUtils.isEmpty(toLoad)) {
            callback(result);
        }
        else {
            this.loadJidResolvers(toLoad, function (users) {
                for (var _i = 0, users_2 = users; _i < users_2.length; _i++) {
                    var user = users_2[_i];
                    result.set(user.uid, user);
                }
                callback(result);
            });
        }
    };
    UsersProvider.prototype.resolveJidsToUserVo = function (jids, callback) {
        var _this = this;
        var result = new Map();
        this.resolveJids(new Set(jids), function (usersIdMap) {
            //Resolve Jid to get userId
            var usersId = new Set();
            for (var _i = 0, jids_1 = jids; _i < jids_1.length; _i++) {
                var jid = jids_1[_i];
                if (usersIdMap.has(jid)) {
                    var userId = usersIdMap.get(jid).userId;
                    if (CheckUtils.isEmpty(userId)) {
                        //result.set(jid, addAnonymous());
                        //alert("undefied")
                    }
                    else {
                        usersId.add(userId);
                    }
                }
                else {
                    //alert("add Anonymous ")
                    result.set(jid, _this.isBot(jid) ? _this.addNewBot() : _this.addAnonymous());
                }
            }
            _this.get(usersId, function (res) {
                for (var _i = 0, jids_2 = jids; _i < jids_2.length; _i++) {
                    var jid = jids_2[_i];
                    if (usersIdMap.has(jid)) {
                        var userId = usersIdMap.get(jid).userId;
                        if (res.has(userId)) {
                            result.set(jid, res.get(userId));
                            continue;
                        }
                    }
                    result.set(jid, null);
                }
                callback(result);
            });
        });
    };
    UsersProvider.prototype.addAnonymous = function () {
        var anonymous = new UserVoData(this._model.nextUserId());
        anonymous.profile.firstName = "anonymous";
        anonymous.profile.color = "#8d93a0";
        anonymous.type = UserTypeVoData.ANONYMOUS;
        anonymous.activationStatus = UserActivationVoStatus.ACTIVATED;
        this._model.add(anonymous);
        return anonymous;
    };
    UsersProvider.prototype.addBot = function () {
        if (!this.model.has(-2))
            this.addNewBot(-2);
    };
    UsersProvider.prototype.addNewBot = function (id) {
        if (CheckUtils.isEmpty(id))
            id = this._model.nextUserId();
        var bot = new UserVoData(id);
        bot.profile.firstName = "bot";
        bot.profile.color = "#8d93a0";
        bot.category = UserCategoryVoData.BOT;
        bot.type = UserTypeVoData.BOT;
        bot.status = UserStatusVoData.ONLINE;
        bot.activationStatus = UserActivationVoStatus.ACTIVATED;
        this._model.add(bot, true);
        return bot;
    };
    UsersProvider.prototype.addBotResolver = function () {
        if (!this._usersResolverModel.has(this.config.jabberAdminReceiver)) {
            this._usersResolverModel.add(new UserResolverVoData(-2, this.config.jabberAdminReceiver));
        }
    };
    UsersProvider.prototype.load = function (usersIds, callback) {
        var _this = this;
        var users = [];
        this.usersEndPoints.get(Array.from(usersIds)).then(function (res) {
            if (res != null) {
                for (var _i = 0, res_1 = res; _i < res_1.length; _i++) {
                    var user = res_1[_i];
                    users.push(UsersConverter.convertToUserVoData(user));
                }
                _this._model.addAll(users);
                if (callback != null)
                    callback(users);
            }
        }).catch(function (err) {
            if (callback != null)
                callback(users);
            logger.info(err);
        });
    };
    UsersProvider.prototype.loadJidResolvers = function (jids, callback) {
        var _this = this;
        var userResolvers = [];
        this.usersEndPoints.getByJid(jids).then(function (results) {
            if (!CheckUtils.isEmpty(results)) {
                for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
                    var result = results_1[_i];
                    var userResolver = UsersConverter.convertToUserResolverVoData(result);
                    if (!_this._usersResolverModel.has(userResolver.uid) &&
                        CheckUtils.isEmpty(userResolver.userId)) {
                        var userVoData = _this.isBot(userResolver.uid) ? _this.addNewBot() : _this.addAnonymous();
                        userResolver.userId = userVoData.id;
                        _this._model.add(userVoData, false);
                        userResolvers.push(userResolver);
                    }
                    else if (!CheckUtils.isEmpty(userResolver.userId)) {
                        userResolvers.push(userResolver);
                    }
                }
            }
            else {
                for (var _a = 0, jids_3 = jids; _a < jids_3.length; _a++) {
                    var jid = jids_3[_a];
                    var userVoData = _this.isBot(jid) ? _this.addNewBot() : _this.addAnonymous();
                    var userResolver = new UserResolverVoData(userVoData.id, jid);
                    _this._model.add(userVoData, false);
                    userResolvers.push(userResolver);
                }
            }
            _this._usersResolverModel.addAll(userResolvers);
            if (callback != null)
                callback(userResolvers);
        }).catch(function (err) {
            if (callback != null)
                callback(userResolvers);
            logger.info(err);
        });
    };
    Object.defineProperty(UsersProvider.prototype, "anonymousLoginName", {
        get: function () {
            return "anonymous@" + this.organizationProvider.model.uri;
        },
        enumerable: true,
        configurable: true
    });
    UsersProvider.prototype.networkStatusChanges = function (res) {
        if (res) {
            var usersResolver = this._usersResolverModel.getAll();
            var usersId = [];
            for (var _i = 0, usersResolver_1 = usersResolver; _i < usersResolver_1.length; _i++) {
                var userResolver = usersResolver_1[_i];
                if (this.authModel.userId == userResolver.userId || this.isPresent(userResolver.uid))
                    usersId.push(userResolver.userId);
            }
            this.model.updateAll([new UpdateModelVoData("status", UserStatusVoData.ONLINE)], false, usersId);
        }
        else {
            this.model.updateAll([new UpdateModelVoData("status", UserStatusVoData.OFFLINE)]);
        }
    };
    UsersProvider.prototype.changePresence = function (uid, presence) {
        var _this = this;
        this.resolveJidsToUserVo([uid], function (users) {
            _this._model.update(users.get(uid).id, [new UpdateModelVoData("status", presence)]);
        });
    };
    UsersProvider.prototype.isBot = function (jid) {
        var regexp = new RegExp('^bot_?');
        return regexp.test(jid);
    };
    UsersProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UsersProvider.ctorParameters = function () { return [
        { type: OdConfig, decorators: [{ type: Inject, args: ['config',] },] },
        { type: UsersEndPoints, },
        { type: UsersModel, },
        { type: Events, },
        { type: CacheService, },
        { type: AuthenticationModel, },
        { type: UsersResolverModel, },
        { type: OrganizationModel, },
        { type: OrganizationProvider, },
    ]; };
    return UsersProvider;
}());
export { UsersProvider };
export var UsersProviderEvent;
(function (UsersProviderEvent) {
    UsersProviderEvent["READY"] = "users-provider:ready";
})(UsersProviderEvent || (UsersProviderEvent = {}));
//# sourceMappingURL=users-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/user/users-provider.js
// module id = 345
// module chunks = 14